import { restClient } from '../config/restClient'

const endpoint = '/users'

export const userSignOut = async () => {
  const response = await restClient(`${endpoint}/sign_out`, {
    method: 'DELETE',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
  })

  return response.data
}
